import { FeatureFlagName } from '../../feature-flags';
import useFeatureFlag from '../../hooks/use-feature-flag';
function useIsTopStripEnabled() {
  return useFeatureFlag(FeatureFlagName.NEXT_PUBLIC_FEAT_FLAG_TOP_STRIP);
}
export default useIsTopStripEnabled;